import { useRef, useState } from "react";
import { useFormContext } from "react-hook-form";
import { Col, Collapse, Form, Row } from "react-bootstrap";
import FontSelector from "./font-selector";
import TextArea from "../../reusable-form-fields/text-area";
import TextField from "../../reusable-form-fields/text-field";
import FileInput from "../../reusable-form-fields/input-file";
import VideoLinkWithPreview from "../../reusable-form-fields/video-link-with-preview";
import ColorPickerWithTextField from "../../reusable-form-fields/color-picker-with-text-field";
import { useTranslation } from "react-i18next";

const SecondBanner = ({
  parseResourceSrc,
  parsePreviewResourceSrc,
  index,
  isFormChanged,
  templateType
}) => {
  const { t } = useTranslation();
  const {
    formState: { errors },
    watch,
    control,
    register
  } = useFormContext();
  const [isValidating, setIsValidating] = useState(false);
  const [isValid, setIsValid] = useState(true);

  const SecondBannerBGColorDisplay = watch(
    `sections[${index}].data.bgColorDisplay`
  );
  const SecondBannerBtnBGColorDisplay = watch(
    `sections[${index}].data.btn.bgColorDisplay`
  );
  const secondBannerBgImage = watch(`sections[${index}].data.image`);
  const youtubeVideoSwitchEnabled = watch(
    `sections[${index}].data.youtubeVideoSwitchEnabled`
  );
  const youtubeVideoLink = watch(`sections[${index}].data.youtubeVideoLink`);

  const secondBannerBgColorPickerRef = useRef();
  const secondBannerHeadingColorPickerRef = useRef();
  const secondBannerParaColorPickerRef = useRef();
  const secondBannerCATButtonColorPickerRef = useRef();
  const secondBannerCATButtonBgColorPickerRef = useRef();

  return (
    <>
      <Row>
        <Col md={3} className="mt-1">
          <ColorPickerWithTextField
            hideButton
            label={t("customerWebsite.BGColor")}
            fieldName={`sections[${index}].data.bgColor`}
            fieldError={
              errors?.sections && errors?.sections[index]?.data?.bgColor
            }
            fieldRef={secondBannerBgColorPickerRef}
            fieldVal={watch(`sections[${index}].data.bgColor`)}
            displayFieldWatcher={SecondBannerBGColorDisplay}
            fieldWatcherName={`sections[${index}].data.bgColorDisplay`}
            isDisabled={Boolean(!SecondBannerBGColorDisplay)}
            setDisplay
            isInGroup
            noSpacing
            hideErrMsg
            isFormChanged={isFormChanged}
          />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col sm={12} md={4}>
          <TextField
            label={t("customerWebsite.heading")}
            placeholder={t("customerWebsite.heading")}
            type="text"
            name={`sections[${index}].data.heading.text`}
            errors={
              errors?.sections && errors?.sections[index]?.data?.heading?.text
            }
            register={register}
            multiline
            noSpacing
          />
        </Col>
        <Col sm={12} md={4}>
          <ColorPickerWithTextField
            hideButton
            label={t("customerWebsite.headingColor")}
            placeholder="#000000"
            fieldName={`sections[${index}].data.heading.color`}
            fieldError={
              errors?.sections && errors?.sections[index]?.data?.heading?.color
            }
            fieldRef={secondBannerHeadingColorPickerRef}
            fieldVal={watch(`sections[${index}].data.heading.color`)}
            defaultColorValue="#000000"
            isInGroup
            noSpacing
            hideErrMsg
            isFormChanged={isFormChanged}
          />
        </Col>
        <Col sm={12} md={4}>
          <FontSelector
            formField={`sections[${index}].data.heading`}
            isFormChanged={isFormChanged}
            asFieldSet
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col sm={12} md={4}>
          <TextArea
            label={t("customerWebsite.para")}
            name={`sections[${index}].data.para.text`}
            register={register}
            errors={
              errors?.sections && errors?.sections[index]?.data?.para?.text
            }
          />
        </Col>
        <Col sm={12} md={4}>
          <ColorPickerWithTextField
            hideButton
            label={t("customerWebsite.paraColor")}
            placeholder="#000000"
            fieldName={`sections[${index}].data.para.color`}
            fieldError={
              errors?.sections && errors?.sections[index]?.data?.para?.color
            }
            fieldRef={secondBannerParaColorPickerRef}
            fieldVal={watch(`sections[${index}].data.para.color`)}
            defaultColorValue="#000000"
            isInGroup
            noSpacing
            hideErrMsg
            isFormChanged={isFormChanged}
          />
        </Col>
        <Col sm={12} md={4}>
          <FontSelector
            formField={`sections[${index}].data.para`}
            isFormChanged={isFormChanged}
            asFieldSet
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col sm={12} md={2}>
          <TextField
            label={t("customerWebsite.ctaBtnText")}
            placeholder={t("customerWebsite.ctaBtnText")}
            type="text"
            name={`sections[${index}].data.btn.text`}
            errors={
              errors?.sections && errors?.sections[index]?.data?.btn?.text
            }
            register={register}
            multiline
            noSpacing
          />
        </Col>
        <Col sm={12} md={2}>
          <TextField
            label={t("customerWebsite.ctaBtnLink")}
            placeholder={t("customerWebsite.ctaBtnLink")}
            type="text"
            name={`sections[${index}].data.btn.link`}
            errors={
              errors?.sections && errors?.sections[index]?.data?.btn?.link
            }
            register={register}
            noSpacing
          />
        </Col>
        <Col sm={12} md={3}>
          <ColorPickerWithTextField
            hideButton
            label={t("customerWebsite.ctaBtnColor")}
            placeholder="#000000"
            fieldName={`sections[${index}].data.btn.color`}
            fieldError={
              errors?.sections && errors?.sections[index]?.data?.btn?.color
            }
            fieldRef={secondBannerCATButtonColorPickerRef}
            fieldVal={watch(`sections[${index}].data.btn.color`)}
            defaultColorValue="#ffffff"
            isInGroup
            noSpacing
            hideErrMsg
            isFormChanged={isFormChanged}
          />
        </Col>
        <Col sm={12} md={3}>
          <ColorPickerWithTextField
            hideButton
            label={t("customerWebsite.ctaBtnBGColor")}
            fieldName={`sections[${index}].data.btn.bgColor`}
            fieldError={
              errors?.sections && errors?.sections[index]?.data?.btn?.bgColor
            }
            fieldRef={secondBannerCATButtonBgColorPickerRef}
            fieldVal={watch(`sections[${index}].data.btn.bgColor`)}
            displayFieldWatcher={SecondBannerBtnBGColorDisplay}
            fieldWatcherName={`sections[${index}].data.btn.bgColorDisplay`}
            isDisabled={Boolean(!SecondBannerBtnBGColorDisplay)}
            setDisplay
            isInGroup
            noSpacing
            hideErrMsg
            isFormChanged={isFormChanged}
          />
        </Col>
        <Col sm={12} md={2}>
          <FontSelector
            formField={`sections[${index}].data.btn`}
            isFormChanged={isFormChanged}
            asFieldSet
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col xs={12} md={6}>
          <Form.Check
            role="button"
            type="switch"
            className="fw-bold"
            label={t("customerWebsite.videoSwitch")}
            {...register(`sections[${index}].data.youtubeVideoSwitchEnabled`)}
          />
        </Col>
      </Row>
      <Collapse in={youtubeVideoSwitchEnabled}>
        <div>
          <VideoLinkWithPreview
            id="for-second-banner"
            name={`sections[${index}].data.youtubeVideoLink`}
            error={
              errors?.sections && errors.sections[index]?.data?.youtubeVideoLink
            }
            control={control}
            isDisabled={isValidating && youtubeVideoLink}
            setIsValid={setIsValid}
            showPreview={youtubeVideoLink && isValid && !isValidating}
            setIsValidating={setIsValidating}
            videoLink={youtubeVideoLink}
          />
        </div>
      </Collapse>
      <Collapse in={!youtubeVideoSwitchEnabled}>
        <div>
          <Row className="mt-3">
            <Col xs={12} md={6}>
              <FileInput
                label={t("customerWebsite.image")}
                name={`sections[${index}].data.image`}
                // resourceId={resourceId}
                parentFolderName={"customer"}
                url={parseResourceSrc(secondBannerBgImage)}
                urlForPreview={parsePreviewResourceSrc(secondBannerBgImage)}
                asset={secondBannerBgImage?.asset}
                error={errors?.sections && errors?.sections[index]?.data?.image}
                isFormChanged={isFormChanged}
                tagName="website_banner_2"
                setDisplay={templateType === "TEMPLATE_3"}
                fieldWatcherName={`sections[${index}].data.image.noClip`}
                displayFieldWatcher={watch(
                  `sections[${index}].data.image.noClip`
                )}
                switchLabel={t("customerWebsite.unclipImage")}
                // selectedCategory={getValues("category")}
              />
            </Col>
          </Row>
        </div>
      </Collapse>
    </>
  );
};

export default SecondBanner;
